export const MAX_FILE_SIZE_BYTES = 15_000_000;

export const COMPRESSED_FILE_SIZE_MB = 0.2;
